var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSustainability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8725 29.9284L47.7493 28.8486H46.765C40.7273 28.8486 36.424 30.297 33.6541 33.066C33.5536 33.1664 33.4646 33.3031 33.368 33.4038C34.3424 34.658 35.0717 35.9707 35.6156 37.3224C37.3356 34.6583 40.2307 32.1798 44.8223 30.8105C40.0025 33.9461 37.7212 38.5698 36.8323 42.1866C37.0185 43.6494 37.086 45.1809 37.086 46.7921C37.086 46.9309 37.0739 47.0685 37.0563 47.2032C39.3881 46.4248 41.5257 45.0788 43.3103 43.2933C46.8274 39.7782 48.4933 34.8749 47.8725 29.9284Z",
    fill: "#F70303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8799 46.793C34.8799 41.4082 34.1369 36.9282 30.2742 33.066C27.5049 30.297 23.273 28.8486 17.2349 28.8486H16.2509L16.128 29.9284C15.5066 34.8749 17.1668 39.7788 20.6829 43.293C23.7014 46.3115 27.7174 48.0005 31.9913 48.0005C32.6607 48.0005 33.2873 47.9704 33.9516 47.8875L34.8796 47.7771L34.8799 46.793ZM23.0163 41.0128C20.6845 38.6821 19.3875 35.6619 19.3034 32.4181C23.2819 32.6773 26.2016 33.7123 27.991 35.5016C30.3622 37.873 31.3926 40.4392 31.6262 44.724C28.3734 44.6351 25.3277 43.325 23.0163 41.0128Z",
    fill: "#F70303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8999 24.944L44.41 19.1421C44.1178 18.4641 43.4788 18.4267 42.9914 19.0602L42.299 19.9598C39.5086 17.5923 35.9041 16 31.9662 16C24.9759 16.0003 19.0207 20.5299 16.8476 26.6087H17.2348C18.4229 26.6087 19.549 26.8166 20.6194 26.9167C22.5679 22.5852 26.9154 19.6335 31.9662 19.6335C35.0884 19.6335 37.9441 20.8303 40.1307 22.7371L40.1191 22.7717L39.4097 23.7037C38.9211 24.3378 39.1211 24.9495 39.8526 25.0567L46.0993 25.9813C46.8324 26.0894 47.1924 25.6236 46.8999 24.944Z",
    fill: "#F70303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainability);
export default __webpack_public_path__ + "static/media/Sustainability.d66e0ec98eb6b6a8b3e151bcc82bcb2b.svg";
export { ForwardRef as ReactComponent };